// import RFQForUnregisterdUser from "../externalPartnerModules/";
import rfq from "./rfq";
import eta from "./eta";

import home from "./home";
import costReview from "./costReview";

const modules = [home, rfq, eta, costReview];

export default modules;
